// import core component
import Link from "next/link";
import { useRef, useEffect, useState } from "react";
import { useRouter } from "next/router";

// import interfaces
import LinkNavProps from "@/interfaces/LinkNav";

export default function LinkNav({
  ariaLabel,
  path,
  className,
  isBlogCategory = false,
  children,
  setToggle,
  setToggleDropdown,
  isBlogPost = false,
  slug,
  id,
}: LinkNavProps) {
  const blogLinkRef = useRef(null);
  const [initialX, setInitialX] = useState(0);
  const [endpointX, setEndpointX] = useState(0);
  const router = useRouter();

  const href = isBlogPost
    ? "/[blog_name]"
    : isBlogCategory
    ? "/blogue/[blog_category]"
    : path;

  function renderAtag() {
    return (
      <a
        ref={blogLinkRef}
        draggable={false}
        aria-label={ariaLabel ? ariaLabel : ""}
        className={className ? className : ""}
        onClick={(e) => {
          if (setToggle) setToggle(false);
          if (setToggleDropdown) setToggleDropdown(false);
          if (
            (initialX + 10 < endpointX ||
              initialX - 10 > endpointX ||
              initialX !== endpointX) &&
            isBlogPost
          ) {
            e.preventDefault();
          }
        }}
      >
        {children}
      </a>
    );
  }

  useEffect(() => {
    if (blogLinkRef.current && isBlogPost) {
      blogLinkRef.current.addEventListener("mousedown", (e) => {
        e.preventDefault();
        setInitialX(e.pageX);
      });

      blogLinkRef.current.addEventListener("mouseup", (e) => {
        e.preventDefault();
        setEndpointX(e.pageX);
      });
    }
  }, []);

  if (isBlogCategory || isBlogPost) {
    return (
      <Link href={href} as={path} passHref>
        {renderAtag()}
      </Link>
    );
  }

  return (
    <Link href={href} passHref>
      {renderAtag()}
    </Link>
  );
}
